import type { FeatureRequestStatus } from '../../../../shared/models/feature-request.models';
import { AdminConfirmDialogService } from '../../../../shared/admin/admin-confirm-dialog.service';

export async function confirmFeatureRequestStatusChange(
  confirmDialog: AdminConfirmDialogService,
  newStatus: FeatureRequestStatus,
  requestNumber?: string,
): Promise<boolean> {
  if (newStatus !== 'DONE' && newStatus !== 'CLOSED') {
    return true;
  }

  const ref = requestNumber ? ` (${requestNumber})` : '';

  if (newStatus === 'DONE') {
    return confirmDialog.confirm({
      title: 'Mark request as Done?',
      message: `This will mark the feature request${ref} as completed and notify platform users. Are you sure you want to continue?`,
      confirmLabel: 'Mark as Done',
    });
  }

  return confirmDialog.confirm({
    title: 'Close this request?',
    message: `This will close the feature request${ref} and notify platform users. Closed requests cannot be reopened in this version. Are you sure?`,
    confirmLabel: 'Close Request',
    confirmVariant: 'danger',
  });
}
